import React from 'react';

import './Actions.scss';
import Enemies from '../Enemies';


const Actions = ({ children, compact=false, sticky=false }) => (
  <div className={`actions${compact?"__compact":""} ${sticky?"actions__sticky":""}`}>
    <Enemies>
      {children}
    </Enemies>
  </div>
);

export default Actions;